// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"cY-z","subtitle":"dY-z","wrapper":"eY-z","leftArrow":"fY-z","rightArrow":"gY-z"};